import { render, staticRenderFns } from "./JockeyView.vue?vue&type=template&id=647500cc"
import script from "./JockeyView.vue?vue&type=script&lang=js"
export * from "./JockeyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports